import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from "../../../context/AuthContext";
import AlertMessage from "../../include/AlertMessage";
import ConfirmationPopup from "../../include/ConfirmationPopup"; // ⬅️ Import new popup
import Pagination from "../../Pagination";

var _ = require('lodash');

function Couponredemtions() {
    const [allRedemtions, setallRedemtions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const token = sessionStorage.getItem('JWT_TOKEN');
    const { crid } = useParams();

    const [alert, setAlert] = useState({ type: "", message: "" });
    const [showPopup, setShowPopup] = useState(false); // popup state
    const [deleteId, setDeleteId] = useState(null); // store user id for delete
    const [deleting, setDeleting] = useState(false);

    const [userNames, setUserNames] = useState({});
    const { role, user } = useAuth();

    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [searchParams, setSearchParams] = useSearchParams();
    const currentPage = Number(searchParams.get("page")) || 1;
    const LIMIT = 10;


    const fetchRedemtions = async (page = currentPage) => {
        try {
            setLoading(true);
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/couponredemtions/${crid}`, {
                params: {
                    page,
                    limit: LIMIT
                },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token // Replace with your token
                }
            });

            const data = await response.data;
            if (Array.isArray(data.data) && data.data.length > 0) {
                const finaldata = data.data;
                setallRedemtions(finaldata);
                fetchUserNames(finaldata);

                setTotalPages(response.data.pagination.totalPages);
                setTotalRecords(response.data.pagination.total);
            }
        } catch (err) {
            const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        } finally {
            setLoading(false);
        }
    };

    const fetchUserNames = async (redemptions) => {
        try {
            let usersMap = {};

            await Promise.all(
                redemptions.map(async (item) => {
                    if (item.user) {
                        const response = await axios.get(
                            `${process.env.REACT_APP_API_URL}/fetchuserdetail/${item.user}`,
                            {
                                headers: {
                                    'Authorization': 'Bearer ' + token
                                }
                            }
                        );

                        usersMap[item.user] = response.data.data.name;
                    }
                })
            );

            setUserNames(usersMap);

        } catch (err) {
            const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        document.documentElement.className = "";

        fetchRedemtions(currentPage);
    }, [currentPage]);

    const handleDelete = async () => {
        if (!deleteId) return;
        try {
            setDeleting(true);
            //setLoading(true);
            const response = await axios.delete(`${process.env.REACT_APP_API_URL}/deletecouponredemtion/${deleteId}`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token // Replace with your token
                    }
                }
            );

            if (response.status === 200 || response.status === 201) {
                const updatedData = allRedemtions.filter(redeem => redeem.$id !== deleteId);

                setallRedemtions(updatedData);
                setAlert({ type: "success", message: "coupon redemption deleted successfully!" });

                // ⭐ If page becomes empty go to previous page
                if (updatedData.length === 0 && currentPage > 1) {
                    setSearchParams({
                        page: currentPage - 1
                    });
                }

                setAlert({ type: "success", message: "coupon redemption deleted successfully!" });
            }
            //fetchRedemtions();
        } catch (err) {
            const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        } finally {
            setShowPopup(false); // close popup after action
            setDeleteId(null); // reset id
            setTimeout(() => {
                setDeleting(false);
            }, 1000);
        }
    };

    return (
        <section>
            <div className="is-title-bar">
                <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
                    <ul>
                        <li><Link to="/dashboard" className='btn btn-primary'>Dashboard</Link></li>
                        <li><Link to="/coupons" className='btn btn-primary'>Coupons</Link></li>
                        <li>Redemptions</li>
                    </ul>
                    {role === "admin" && (
                        <Link to={`/couponredemtion/add/${crid}`} className='button blue'>Add Redemption</Link>
                    )}
                </div>
            </div>
            <div className="section main-section">
                <div className="grid gap-6 grid-cols-1 md:grid-cols-12">
                    <div className="card">
                        <header className="card-header">
                            <p className="card-header-title">
                                <span className="icon"><i className="mdi mdi-reorder-horizontal"></i></span>
                                All Redemptions
                            </p>
                        </header>
                        <div className="card-content">
                            {alert.message && (
                                <AlertMessage
                                    type={alert.type}
                                    message={alert.message}
                                    onClose={() => setAlert({ type: "", message: "" })}
                                    duration={3000}
                                />
                            )}
                            {loading ? (
                                <div className="flex justify-center items-center py-10">
                                    <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid"></div>
                                </div>

                            ) : (
                                Array.isArray(allRedemtions) && allRedemtions.length > 0 ? (
                                    <>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>User</th>
                                                    <th>Latitude</th>
                                                    <th>Longitude</th>
                                                    <th>Redeemed At</th>
                                                    {role === "admin" && <th></th>}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(allRedemtions || []).map((item, index) => (
                                                    <tr key={item.$id}>
                                                        <td data-label="users"> {userNames[item.user] || "Loading..."}</td>
                                                        <td data-label="latitude">{item.latitude}</td>
                                                        <td data-label="longitude">{item.longitude}</td>
                                                        <td data-label="Redeemed At">{item.$createdAt?.replace('T', ' ').split('.')[0]}</td>
                                                        {role === "admin" && (
                                                            <td className="actions-cell">
                                                                <div className="buttons right nowrap">
                                                                    <Link to={`/couponredemtion/edit/${item.$id}?page=${currentPage}`} className='button small green'> <span className="icon"><i className="mdi mdi-lead-pencil"></i></span></Link>
                                                                    <button
                                                                        className="button small red"
                                                                        type="button"
                                                                        onClick={() => {
                                                                            if (deleting) return;
                                                                            setDeleteId(item.$id);
                                                                            setShowPopup(true);
                                                                        }}
                                                                        style={{
                                                                            cursor: deleting ? "not-allowed" : "pointer",
                                                                            opacity: deleting ? 0.5 : 1
                                                                        }}
                                                                    >
                                                                        <span className="icon"><i className="mdi mdi-trash-can"></i></span>
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        )}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>

                                        {totalPages > 1 && (
                                            <Pagination
                                                currentPage={currentPage}
                                                totalPages={totalPages}
                                                totalRecords={totalRecords}
                                                onPageChange={(page) =>
                                                    setSearchParams({
                                                        page
                                                    })
                                                }
                                            />
                                        )}
                                    </>
                                ) : (
                                    <p style={{ color: 'red', fontWeight: 'bold', textAlign: 'center' }}>No Record Found.</p>
                                )
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {/* Confirmation Popup */}
            <ConfirmationPopup
                show={showPopup}
                onConfirm={handleDelete}
                onCancel={() => {
                    if (!deleting) {
                        setShowPopup(false);
                    }
                }}
                title="Confirm Delete"
                message={
                    deleting
                        ? "Deleting coupon redemption..."
                        : "Are you sure you want to delete this coupon redemption?"
                }
                deleting={deleting}
            />
        </section>
    );
};

export default Couponredemtions;